import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginRouteBlockGuard implements CanActivate {
  loginStatus: boolean = false;
  constructor( private router: Router, )
  {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      this.loginStatus = localStorage.getItem("user_session_id") ? true : false;

      // 
      if(this.loginStatus === true)
      {
        this.router.navigate(['/cms/catalogs']);
        return false;
      }
      else
      {
        // this.router.parseUrl('');
        // this.router.navigate(['']);
        return true
        // return true;
      }
  }
  
}
